import { BrazeInboxMessageCardDto } from '@marketplace-web/shared/braze-data'
import { ConversationListItemType } from '@marketplace-web/domain/conversation-messaging-data'

export const isBrazeConversation = (
  conversation: ConversationListItemType,
): conversation is BrazeInboxMessageCardDto => 'extras' in conversation

const getConversationTime = (conversation: ConversationListItemType) => {
  return isBrazeConversation(conversation)
    ? conversation.updated.getTime()
    : new Date(conversation?.updated_at || 0).getTime()
}

export const sortConversations = (conversations: Array<ConversationListItemType>) => {
  return [...conversations].sort(
    (firstConversation, secondConversation) =>
      getConversationTime(secondConversation) - getConversationTime(firstConversation),
  )
}

export const getConversationIdFromUrl = (relativeUrl: string) => {
  const id = relativeUrl.substring(relativeUrl.lastIndexOf('/') + 1)

  if (['inbox', 'new'].includes(id)) {
    return ''
  }

  return id
}
